import { cB as e, cE as t, c as o, cM as r } from "./ghl-ui.es384.js";
const n = e("carousel", `
 position: relative;
 width: 100%;
 height: 100%;
 touch-action: pan-y;
 overflow: hidden;
`, [t("slides", `
 display: flex;
 width: 100%;
 height: 100%;
 transition-timing-function: var(--n-bezier);
 transition-property: transform;
 `, [t("slide", `
 flex-shrink: 0;
 position: relative;
 width: 100%;
 height: 100%;
 outline: none;
 overflow: hidden;
 `, [o("> img", `
 display: block;
 `)])]), t("dots", `
 position: absolute;
 display: flex;
 flex-wrap: nowrap;
 `, [r("dot", [t("dot", `
 height: var(--n-dot-size);
 width: var(--n-dot-size);
 background-color: var(--n-dot-color);
 border-radius: 50%;
 cursor: pointer;
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 outline: none;
 `, [o("&:focus", `
 background-color: var(--n-dot-color-focus);
 `), r("active", `
 background-color: var(--n-dot-color-active);
 `)])]), r("line", [t("dot", `
 border-radius: 9999px;
 width: var(--n-dot-line-width);
 height: 4px;
 background-color: var(--n-dot-color);
 cursor: pointer;
 transition:
 width .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 outline: none;
 `, [o("&:focus", `
 background-color: var(--n-dot-color-focus);
 `), r("active", `
 width: var(--n-dot-line-width-active);
 background-color: var(--n-dot-color-active);
 `)])])]), t("arrow", `
 transition: background-color .3s var(--n-bezier);
 cursor: pointer;
 height: 28px;
 width: 28px;
 display: flex;
 align-items: center;
 justify-content: center;
 background-color: rgba(255, 255, 255, .2);
 color: var(--n-arrow-color);
 border-radius: 8px;
 user-select: none;
 -webkit-user-select: none;
 font-size: 18px;
 `, [o("svg", `
 height: 1em;
 width: 1em;
 `), o("&:hover", `
 background-color: rgba(255, 255, 255, .3);
 `)]), r("vertical", `
 touch-action: pan-x;
 `, [t("slides", `
 flex-direction: column;
 `), r("fade", [t("slide", `
 top: 50%;
 left: unset;
 transform: translateY(-50%);
 `)]), r("card", [t("slide", `
 top: 50%;
 left: unset;
 transform: translateY(-50%) translateZ(-400px);
 `, [r("current", `
 transform: translateY(-50%) translateZ(0);
 `), r("prev", `
 transform: translateY(-100%) translateZ(-200px);
 `), r("next", `
 transform: translateY(0%) translateZ(-200px);
 `)])])]), r("usercontrol", [t("slides", [o(">", [o("div", `
 position: absolute;
 top: 50%;
 left: 50%;
 width: 100%;
 height: 100%;
 transform: translate(-50%, -50%);
 `)])])]), r("left", [t("dots", `
 transform: translateY(-50%);
 top: 50%;
 left: 12px;
 flex-direction: column;
 `, [r("line", [t("dot", `
 width: 4px;
 height: var(--n-dot-line-width);
 margin: 4px 0;
 transition:
 height .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 outline: none;
 `, [r("active", `
 height: var(--n-dot-line-width-active);
 `)])])]), t("dot", `
 margin: 4px 0;
 `)]), t("arrow-group", `
 position: absolute;
 display: flex;
 flex-wrap: nowrap;
 `), r("vertical", [t("arrow", `
 transform: rotate(90deg);
 `)]), r("show-arrow", [r("bottom", [t("dots", `
 transform: translateX(0);
 bottom: 18px;
 left: 18px;
 `)]), r("top", [t("dots", `
 transform: translateX(0);
 top: 18px;
 left: 18px;
 `)]), r("left", [t("dots", `
 transform: translateX(0);
 top: 18px;
 left: 18px;
 `)]), r("right", [t("dots", `
 transform: translateX(0);
 top: 18px;
 right: 18px;
 `)])]), r("left", [t("arrow-group", `
 bottom: 12px;
 left: 12px;
 flex-direction: column;
 `, [o("> *:first-child", `
 margin-bottom: 12px;
 `)])]), r("right", [t("dots", `
 transform: translateY(-50%);
 top: 50%;
 right: 12px;
 flex-direction: column;
 `, [r("line", [t("dot", `
 width: 4px;
 height: var(--n-dot-line-width);
 margin: 4px 0;
 transition:
 height .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 outline: none;
 `, [r("active", `
 height: var(--n-dot-line-width-active);
 `)])])]), t("dot", `
 margin: 4px 0;
 `), t("arrow-group", `
 bottom: 12px;
 right: 12px;
 flex-direction: column;
 `, [o("> *:first-child", `
 margin-bottom: 12px;
 `)])]), r("top", [t("dots", `
 transform: translateX(-50%);
 top: 12px;
 left: 50%;
 `, [r("line", [t("dot", `
 margin: 0 4px;
 `)])]), t("dot", `
 margin: 0 4px;
 `), t("arrow-group", `
 top: 12px;
 right: 12px;
 `, [o("> *:first-child", `
 margin-right: 12px;
 `)])]), r("bottom", [t("dots", `
 transform: translateX(-50%);
 bottom: 12px;
 left: 50%;
 `, [r("line", [t("dot", `
 margin: 0 4px;
 `)])]), t("dot", `
 margin: 0 4px;
 `), t("arrow-group", `
 bottom: 12px;
 right: 12px;
 `, [o("> *:first-child", `
 margin-right: 12px;
 `)])]), r("fade", [t("slide", `
 position: absolute;
 opacity: 0;
 transition-property: opacity;
 pointer-events: none;
 `, [r("current", `
 opacity: 1;
 pointer-events: auto;
 `)])]), r("card", [t("slides", `
 perspective: 1000px;
 `), t("slide", `
 position: absolute;
 left: 50%;
 opacity: 0;
 transform: translateX(-50%) translateZ(-400px);
 transition-property: opacity, transform;
 `, [r("current", `
 opacity: 1;
 transform: translateX(-50%) translateZ(0);
 z-index: 1;
 `), r("prev", `
 opacity: 0.4;
 transform: translateX(-100%) translateZ(-200px);
 `), r("next", `
 opacity: 0.4;
 transform: translateX(0%) translateZ(-200px);
 `)])])]);
export {
  n as default
};
